import React from 'react';

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';

import useStyles from '@components/AccountsPayableCustomTable/styles';

export interface HeadCell {
  disablePadding: boolean;
  id: string;
  label: string;
  align: any;
  visible: boolean;
}

interface EnhancedTableProps {
  headCells: HeadCell[];
  classes: ReturnType<typeof useStyles>;
  numSelected: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowCount: number;
  grouped?: boolean;
  totalVisibleColumns: number;
  canSelect: boolean;
}

const EnhancedTableHead = (props: EnhancedTableProps) => {
  const {
    headCells,
    onSelectAllClick,
    numSelected,
    rowCount,
    grouped = false,
    totalVisibleColumns,
    canSelect,
  } = props;
  const classes = useStyles({});

  const p = 5 * totalVisibleColumns;
  const rest = p - 20;

  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        <TableCell padding="checkbox" className={classes.tableHeadCell}>
          {!grouped && canSelect && (
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all desserts' }}
            />
          )}
        </TableCell>
        {headCells.map((headCell) =>
          headCell.visible ? (
            <TableCell
              style={{ width: headCell.id === 'provider' ? `${50 - rest}%` : 200 }}
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              className={classes.tableHeadCell}
            >
              {headCell.label}
            </TableCell>
          ) : null,
        )}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
